<template>
  <v-card flat class="grow">
    <v-card outlined class="grow mb-4">
      <NodalPCQuickLook
        :case-outputs="caseOutputs"
        :input-case="inputCase"
        :horizontal="true"
        :selectedTab="selectedTab"
        :selectedNodeId="selectedNodeId"
      />
    </v-card>
    <v-card v-if="viewMode === 'dashboard'" flat class="grow">
      <NodalPCDashboard
        :case-outputs="caseOutputs"
        :input-case="inputCase"
        :selectedTab="selectedTab"
        :selectedNodeId="selectedNodeId.nodeId"
      />
    </v-card>
    <v-card v-else flat class="grow">
      <v-col cols="12">
        <NodalPCTabular
          :case-outputs="caseOutputs"
          :input-case="inputCase"
          :selectedTab="selectedTab"
          :selectedNodeId="selectedNodeId"
        />
      </v-col>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: "OutputNodalPCDashboard",
  components: {
    NodalPCQuickLook: () => import("@/components/dashboards/NodalPCQuickLook.vue"),
    NodalPCDashboard: () => import("@/components/dashboards/NodalPCDashboard.vue"),
    NodalPCTabular: () => import("@/components/dashboards/NodalPCTabular.vue"),
  },
  mixins: [],
  props: {
    selectedTab: { type: String, required: true, default: "systemLevel" },
    caseOutputs: { type: Object, required: true },
    inputCase: { type: Object, required: true },
    viewMode: { type: String, required: true, default: "dashboard" },
    logoUrl: { type: String, required: true },
  },
  data() {
    return {
      selectedNodeId: {
        nodeId: 1,
      },
    };
  },
  computed: {
    displayDivider() {
      return this.$vuetify.breakpoint.smAndUp;
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
